var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContentsTabSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 22,
    viewBox: "0 0 34 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.4318 4H9.5682C8.695 4 8 3.1 8 2C8 0.9 8.71282 0 9.5682 0H32.4318C33.305 0 34 0.9 34 2C34 3.1 33.305 4 32.4318 4Z",
    fill: "#00BAC7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4318 22H9.5682C8.695 22 8 21.1 8 20C8 18.9 8.71282 18 9.5682 18H32.4318C33.305 18 34 18.9 34 20C34 21.1 33.305 22 32.4318 22Z",
    fill: "#00BAC7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4318 13H9.5682C8.695 13 8 12.1 8 11C8 9.9 8.71282 9 9.5682 9H32.4318C33.305 9 34 9.9 34 11C34 12.1 33.305 13 32.4318 13Z",
    fill: "#00BAC7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 4C3.10457 4 4 3.10457 4 2C4 0.89543 3.10457 0 2 0C0.89543 0 0 0.89543 0 2C0 3.10457 0.89543 4 2 4Z",
    fill: "#00BAC7"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 13C3.10457 13 4 12.1046 4 11C4 9.89543 3.10457 9 2 9C0.89543 9 0 9.89543 0 11C0 12.1046 0.89543 13 2 13Z",
    fill: "#00BAC7"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22C3.10457 22 4 21.1046 4 20C4 18.8954 3.10457 18 2 18C0.89543 18 0 18.8954 0 20C0 21.1046 0.89543 22 2 22Z",
    fill: "#00BAC7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentsTabSelected);
export default __webpack_public_path__ + "static/media/contents-tab-selected.b52cd275.svg";
export { ForwardRef as ReactComponent };